// Whether the screen is holding something the server has not been told about yet - today that is
// prices a supplier has typed into the quote list but not saved. A full page reload throws it away,
// so the two tabs that reload on click ask here first.
let unsaved = false;
export const setUnsaved = (v) => { unsaved = !!v; };
export const hasUnsaved = () => unsaved;
